import { render, staticRenderFns } from "./land-news.vue?vue&type=template&id=57abb581&"
import script from "./land-news.vue?vue&type=script&lang=js&"
export * from "./land-news.vue?vue&type=script&lang=js&"
import style0 from "./land-news.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports